// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root{--single-bg-brd-color: 200, 200, 200}.single-card-grid .single-code .qrcode{width:100%}.single-card-grid .single-code .qrcode svg{width:100% !important}`, "",{"version":3,"sources":["webpack://./src/styles/_variables.scss","webpack://./src/codes/components/qr.component.scss"],"names":[],"mappings":"AAAA,MACE,oCAAA,CCCF,uCACE,UAAA,CAGF,2CACE,qBAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
